<template>
    <div class="w-full flex flex-column
        gap-3 xl:gap-4 lg:gap-3 md:gap-3
        mb-5 xl:mb-7 lg:mb-6 md:mb-5
        pr-0">

        <!--WALLET-->
        <div class="w-full flex border-round-xl overflow-hidden">
            <WalletWidget v-if="wallet" @refresh="getWallet"
                :title="content[lang_].walletTitle"
                :balance="wallet.balance" 
                :currency="'usdt'" 
                :wallets="wallets"
                :wallet_id="wallet.id" 
                :wallet_type="wallet.type"
                :loading="isLoading" 
                :btnTopup="false"
                :btnWithdraw="false"
                />
        </div>

        <!--data-->
        <div class="flex flex-row
            gap-3 xl:gap-4 lg:gap-3 md:gap-3">
            <div class="w-full flex flex-column flex-1 surface-0
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left relative">
                <span class="flex text-600 mb-2 text-sm font-medium pr-4">
                    {{ content[lang_].personal_percent }}
                </span>
                <span v-if="partner && partner.ref && partner.ref.percent" class="flex text-700 text-3xl font-medium white-space-nowrap">
                    {{ getPercent(partner.ref.percent) }}%
                </span>
                <Skeleton height="2rem" v-else />
                <!-- <div v-if="partnerUserCount" class="mt-2">
                    <Button label="Поднять" size="small" class="flex bg-green-100 text-green-600 border-0 border-transparent border-round-xl text-xs" />
                </div> -->
            </div>
            <div @click="showTableTrans=true"
                class="w-full flex flex-column flex-1 surface-0 hover:shadow-2
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left cursor-pointer relative">
                <span class="flex text-600 mb-2 text-sm font-medium pr-4">
                    {{ content[lang_].tb_trans_title }}
                </span>
                <span v-if="partnerTransCount!=null" class="flex text-700 text-3xl font-medium white-space-nowrap">
                    {{ partnerTransCount }}
                </span>
                <Skeleton height="2rem" v-else />
                <div v-if="partnerUserCount" class="mt-2">
                    <Button label="Все" icon="pi pi-expand" iconPos="right" class="flex" size="small" severity="secondary" />
                </div>
            </div>
        </div>
        <div class="flex flex-row
            gap-2 xl:gap-4 lg:gap-3 md:gap-3">
            <div @click="showTableUsers=true" 
                class="w-full flex flex-column flex-1 surface-0 hover:shadow-2
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left cursor-pointer relative">
                <span class="flex text-600 mb-2 text-sm font-medium pr-4">
                    {{ content[lang_].count_users }} 
                </span>
                <div v-if="partnerUserCount!=null" class="w-full flex flex-row">
                    <span class="flex text-700 text-4xl font-medium white-space-nowrap">
                        {{ partnerUserCount }}
                    </span>
                    <AvatarGroup class="flex ml-3" v-if="avatars && avatars.length>0">
                        <Avatar v-for="(avatar, index) of avatars" :key="index" :image="avatar" shape="circle" />
                        <Avatar v-if="getRestCount()" :label="`${getRestCount()}`" shape="circle" class="text-xs"/>
                    </AvatarGroup>
                </div>
                <Skeleton height="2rem" v-else />
                <div v-if="partnerUserCount" class="mt-2">
                    <Button label="Все" icon="pi pi-expand" iconPos="right" class="flex" size="small" severity="secondary" />
                </div>
            </div>
        </div>

        <!--web link-->
        <div v-if="!isTgApp" class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row pr-0 
            gap-2 xl:gap-4 lg:gap-3 md:gap-3
            border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
            overflow-hidden hover:shadow-2">
            <div class="w-full flex flex-column flex-1 surface-0 
                p-3 xl:p-4 lg:p-4 md:p-4 
                relative
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left cursor-pointer" v-if="partner_link" @click="copy(partner_link)" >
                <span class="flex text-600 mb-2 text-sm font-medium">
                    {{ content[lang_].href }}
                </span>
                <span 
                    class="flex text-700 font-medium white-space-nowrap
                    text-sm xl:text-2xl lg:text-xl md:text-lg">
                    <span>{{ partner_link }}</span>
                </span>
                <div class="pi pi-copy absolute text-500 right-0 top-0 mr-3 mt-3"></div>
            </div>
        </div>

        <!--tg link-->
        <div v-if="isTgApp" class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row pr-0 
            gap-2 xl:gap-4 lg:gap-3 md:gap-3
            overflow-hidden">
            <div class="w-full flex flex-row gap-2">
                <div class="flex flex-1 flex-column surface-0 hover:shadow-2
                    p-3 xl:p-4 lg:p-4 md:p-4 
                    relative overflow-hidden
                    border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                    text-left cursor-pointer" v-if="partner_link_tg" @click="copy(partner_link_tg)" >
                    <span class="flex text-600 mb-2 text-sm">
                        {{ content[lang_].href_ }}:
                    </span>
                    <span 
                        class="flex text-700 font-medium white-space-nowrap
                        text-sm xl:text-2xl lg:text-xl md:text-lg" style="height:1.2em">
                        <span class="absolute">{{ partner_link_tg }}</span>
                    </span>
                    <div class="pi pi-copy absolute text-500 right-0 top-0 mr-3 mt-3"></div>
                </div>
                <div class="flex surface-0 hover:shadow-2
                    p-3 xl:p-4 lg:p-4 md:p-4 
                    relative
                    border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                    vertical-align-middle
                    text-left cursor-pointer" v-if="partner_link_tg" @click="shareTg(partner_link_tg)" 
                    style="width:50px;">
                    <div class="flex pi pi-upload text-500"></div>
                </div>
            </div>
        </div>

        <!--rules-->
        <div v-if="rules && rules.length>0" class="w-full">
            <span @click="showRules=true" class="text-primary cursor-pointer">
                <i class="pi pi-clipboard" style="font-size: 1rem"></i> {{content[lang_].link_rules_title}}
            </span>
        </div>
    </div>

    <!--TABLE USERS POPUP-->
    <Dialog v-model:visible="showTableUsers" :header="content[lang_].tb_users_title" modal blockScroll
        :style="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { width: '100%', height: '100%' } : { width: '75vw' }" 
        :contentStyle="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { height: '100%' } : { height: '500px' }"
        class="m-2">
    
        <div v-if="users && partnerUserCount>0">
            <DataTable v-if='users' :value="users" responsiveLayout="scroll"
                lazy paginator :rows="10" :rowsPerPageOptions="[10, 20, 50, 100]" :totalRecords="totalUsers"
                @page="onPageUser($event)" @sort="onSortUser($event)" :loading="loadingUsers">

                <Column field="name">
                    <template #header>
                        <span class="text-xs">{{ content[lang_].header_name }}</span>
                    </template>
                    <template #body="{ data }">
                        <span class="text-xs flex flex-row">
                            {{ data.name }}
                        </span> 
                    </template>
                </Column>

                <Column field="date_created">
                    <template #header>
                        <span class="text-xs">{{ content[lang_].header_date }}</span>
                    </template>
                    <template #body="{ data }">
                        <span class="text-xs flex flex-row">
                            {{ formatDate(data.date_created) }}
                        </span>
                    </template>
                </Column>

                <template #footer>
                    <span class="text-sm flex flex-row">
                        {{content[lang_].all}} {{ totalUsers }} 
                    </span>
                </template>

            </DataTable>
        </div>
        <Skeleton height="2rem" v-if="users==null" />
        <div v-if="partnerUserCount==0 && users!=null">
            <span class="mt-2 block">{{content[lang_].tb_users_empty}}</span>
        </div>
    </Dialog>

    <!--TABLE TRANS POPUP-->
    <Dialog v-model:visible="showTableTrans" :header="content[lang_].tb_trans_title" modal blockScroll
        :style="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { width: '100%', height: '100%' } : { width: '75vw' }" 
        :contentStyle="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { height: '100%' } : { height: '500px' }"
        class="m-2">

        <div v-if="trans && partnerTransCount > 0">
            <DataTable v-if='trans' :value="trans" class="mt-3" responsiveLayout="scroll"
                lazy paginator :rows="10" :rowsPerPageOptions="[10, 20, 50, 100]" :totalRecords="totalTrans"
                @page="onPageTrans($event)" @sort="onSortTrans($event)" :loading="loadingTrans">

                <Column field="amount.$numberDecimal" :exportable="false">
                    <template #header>
                        <span class="text-xs">{{ content[lang_].header_sum }}</span>
                    </template>
                    <template #body="{ data }">
                        <span class="text-xs">{{ get_format_amount(data.amount.$numberDecimal, 'usd') }}</span>
                    </template>
                </Column>

                <Column field="direction" :exportable="false">
                    <template #header>
                        <span class="text-xs">{{ content[lang_].header_desc }}</span>
                    </template>
                    <template #body="{ data }">
                        <span class="text-xs">{{(data.direction=='in') ? content[lang_].direction_in : content[lang_].direction_out}}</span>
                    </template>
                </Column>

                <Column field="created_at">
                    <template #header>
                        <span class="text-xs">{{ content[lang_].header_date }}</span>
                    </template>
                    <template #body="{ data }">
                        <span class="text-xs flex flex-row">
                            {{ formatDate(data.created_at) }}
                        </span>
                    </template>
                </Column>
                
                <template #footer>
                    <span class="text-sm flex flex-row">
                        {{content[lang_].all}} {{ totalTrans }}
                    </span>
                </template>

            </DataTable>
        </div>
        <Skeleton height="2rem" v-if="trans==null" />
        <div v-if="partnerTransCount==0 && trans!=null">
            <span class="mt-2 block">{{content[lang_].tb_trans_empty}}</span>
        </div>
    </Dialog>

    <!--INVITE POPUP-->
    <Dialog v-model:visible="showInvitePopUp" :header="content[lang_].invite_header" modal blockScroll
        :style="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { width: '100%', height: '100%' } : { width: '75vw' }" 
        :contentStyle="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { height: '100%' } : { height: '500px' }"
        class="mx-2">
        <div class="w-full">

            <div class="w-full mb-5">
                <div class="flex mb-2 relative align-items-center">
                    <span class="flex text-600">
                        {{ content[lang_].invite_via_web }}
                    </span>
                </div>

                <div @click="copy(partner_link)"
                    class="w-full flex flex-column flex-1 surface-0 
                    p-3 xl:p-4 lg:p-4 md:p-4
                    border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                    text-left cursor-pointer relative">
                        <span class="flex text-600 mb-2 text-sm">
                            {{ content[lang_].href }}
                        </span>
                    <span 
                        class="flex text-700 font-medium white-space-nowrap
                        text-sm xl:text-2xl lg:text-xl md:text-lg pr-4">
                        <span>{{ partner_link }}</span>
                    </span>
                    <div class="pi pi-copy absolute text-500 right-0 top-0 mr-3 mt-3"></div>
                </div>
            </div>

            <div class="w-full mb-5">
                <div class="flex mb-2 relative align-items-center">
                    <span class="flex text-600">
                        {{ content[lang_].invite_via_tg }}
                    </span>
                </div>
                
                <div class="w-full flex flex-row gap-2 mb-4">
                    <div class="flex flex-1 flex-column surface-0 hover:shadow-2
                        p-3 xl:p-4 lg:p-4 md:p-4 
                        relative overflow-hidden
                        border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                        text-left cursor-pointer" v-if="partner_link_tg" @click="copy(partner_link_tg)" >
                        <span class="flex text-600 mb-2 text-sm">
                            {{ content[lang_].href_ }}
                        </span>
                        <span 
                            class="flex text-700 font-medium white-space-nowrap
                            text-sm xl:text-2xl lg:text-xl md:text-lg" style="height:1.2em">
                            <span class="absolute">{{ partner_link_tg }}</span>
                        </span>
                        <div class="pi pi-copy absolute text-500 right-0 top-0 mr-3 mt-3"></div>
                    </div>
                    <div v-if="partner_link_tg && isTgApp" @click="shareTg(partner_link_tg)" 
                        class="flex surface-0 hover:shadow-2
                            p-3 xl:p-4 lg:p-4 md:p-4 
                            relative
                            border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                            vertical-align-middle
                            text-left cursor-pointer" 
                        style="width:50px;">
                        <div class="flex pi pi-upload text-500"></div>
                    </div>
                </div>
            </div>
        </div>
    </Dialog>

    <!--RULES POPUP-->
    <Dialog v-model:visible="showRules" :header="content[lang_].agree_title" modal blockScroll
        :style="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { width: '100%', height: '100%' } : { width: '75vw' }" 
        :contentStyle="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { height: '100%' } : { height: '500px' }"
        class="w-full max-w-30rem mx-2">
        <div class="w-full">
            <span v-for="(rule, index) of rules" :key="index"
                class="flex text-600 mb-3">
                {{ index+1 }}. {{ rule[lang_] }}
            </span>
        </div>
        <template #footer>
            <span class="w-full flex">
                <Button :label="content[lang_].ok" icon="pi pi-check" @click="showRules=false" class="flex border-round-lg p-button-lg w-full surface-200 text-600 border-0" :loading="isLoading"/>
            </span>
        </template>
    </Dialog>

    <!--WITHDRAW POPUP-->
    <Dialog v-model:visible="showWithdrawPopup" :header="content[lang_].withdraw_title" modal blockScroll
        :style="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { width: '100%', height: '100%' } : { width: '75vw' }" 
        :contentStyle="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screen_size=='xs') ? 'h-full' : ''"
        class="w-full max-w-30rem">
        <div class="w-full">
            <div class="flex flex-column mb-3">
                <label for="number" class="w-full mb-2">
                    {{ message[lang_].sum_title }}
                </label>
                <InputNumber v-model="message_sum" id="message_sum" class="flex-auto h-3rem w-full" :useGrouping="false" :min="0" :max="getMaxSum()" />
            </div>
        </div>
        <template #footer>
            <div class="flex w-full">
                <Button type="button" :label="message[lang_].btn" severity="secondary" @click="sendMessage" :loading="isLoading" 
                class="flex flex-1 bg-green-100 text-green-600 border-0 border-round-lg text-sm font-medium p-button-lg" icon="pi pi-arrow-down" iconPos="right" />
            </div>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import BigNumber from 'bignumber.js'
import partnerRules from '@/assets/json/partnerRules.json'
import WalletWidget from    '@/components/personal/wallet/WalletWidget.vue'
import { mapActions } from  'vuex'

export default {
    props: ['show_invite'],
    data() {
        return {
            partner_link: null,
            partner_link_tg: null,
            partner: null,
            partnerUserCount: null,
            partnerTransferCount: null,
            partnerTransCount: null,
            avatarCount: 0,

            showTableUsers: false,
            showTableTransfers: false,
            showTableTrans: false,
            showRules: false,
            showInvitePopUp: false,
            showWithdrawPopup: false,

            users: null,
            transfers: null,
            trans: null,
            avatars: [],
            rules: [],

            active: 0,
            lazyParams: {},

            totalUsers: 0,
            totalTransfers: 0,
            totalComission: 0,
            totalTrans: 0,

            message_sum: 0,
                
            loadingUsers: false,
            loadingTransfers: false,
            loadingTrans: false,

            isLoading: false,

            defaulParams: {
                first: 0,
                rows: 10,
                sortField: null,
                sortOrder: null,
                filters: null,
            },

            wallet: null,
            wallet_id: null,
            
            content: {
                ru: {
                    title: 'Кабинет партнера',
                    walletTitle: 'Партнерский счет',
                    btn_invite: 'Пригласить',
                    btn_payout: 'Вывести',
                    agree_title: 'Партнерское соглашение',
                    be_partner_btn: 'Стать партнером',
                    href: 'Ссылка для сайта',
                    href_: 'Ссылка для Telegram',
                    balance: 'Баланс партнера',
                    no_wallet: 'У вас нет партнерского кошелька',
                    count_users: 'Приглашенных',
                    count_transfers: 'Количество переводов',
                    tb_users_title: 'Список приглашенных пользователей',
                    tb_users_empty: 'У вас нет приглашенных пользователей',
                    tb_transfers_title: 'Список совершенных переводов',
                    tb_transfers_empty: 'У ваших пользователей нет переводов',
                    tb_trans_title: 'Начисления',
                    tb_trans_empty: 'У вас нет начислений',
                    copy: 'Скопировано',
                    personal_percent: 'Ваш процент',
                    header_sum: 'Сумма',
                    header_desc: 'Операция',
                    header_date: 'Дата',
                    header_name: 'Имя',
                    direction_in: 'Зачисление',
                    direction_out: 'Списание',
                    all: 'Всего',
                    elements: 'записей',
                    link_rules_title: 'Правила партнерской программы',
                    invite_header: 'Как пригласить друзей',
                    invite_via_web: 'Отправьте вашу партнерскую ссылку на сайт вашему другу и попросите его сделать тестовый перевод.',
                    invite_via_tg: 'А если по ссылке в телеграм приложении можно делать переводы без регистрации.',
                    ok: 'Ок',
                    withdraw_title: 'Вывод средств',
                },
                en: {
                    title: "Partner's account",
                    walletTitle: "Partner's wallet",
                    btn_invite: 'Invite',
                    btn_payout: 'Withdraw',
                    agree_title: 'Affiliate agreement',
                    be_partner_btn: 'Become a partner',
                    href: 'Your referral link',
                    href_: 'Your referral link for Telegram',
                    balance: 'Partner balance',
                    no_wallet: 'You have no partner wallet',
                    count_users: 'Referrals',
                    count_transfers: 'Number of transfers',
                    tb_users_title: 'List of invited users',
                    tb_users_empty: 'You have no invited users',
                    tb_transfers_title: 'List of transfers',
                    tb_transfers_empty: 'Your users have no transfers',
                    tb_trans_title: 'Accruals',
                    tb_trans_empty: 'You have no accruals',
                    copy: 'Copied',
                    personal_percent: 'Your percent',
                    header_sum: 'Sum',
                    header_desc: 'Operation',
                    header_date: 'Date',
                    header_name: 'Name',
                    direction_in: 'Accrual',
                    direction_out: 'Write-off',
                    all: 'Total',
                    elements: 'records',
                    link_rules_title: 'Affiliate program rules',
                    invite_header: 'How to invite friends',
                    invite_via_web: 'Send your referral link to your friend and ask him to make a test transfer.',
                    invite_via_tg: 'And if you can make transfers without registration via the link in the telegram application.',
                    ok: 'Ok',
                    withdraw_title: 'Withdraw funds',
                }
            },
            message: {
                ru: {
                    sum_title: 'Укажите сумму вывода',
                    btn: 'Вывести',
                    success: 'Успех',
                    sent: 'Заявка на вывод отправлена',
                    error: 'Ошибка',
                    notsent: 'Ошибка отправки заявки на вывод'
                },
                en: {
                    sum_title: 'Enter the withdrawal amount',
                    btn: 'Withdraw',
                    success: 'Success',
                    sent: 'Withdrawal request sent',
                    error: 'Error',
                    notsent: 'Error sending withdrawal request'
                }
            }
        }
    },
    components: {
        WalletWidget
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screen_size() { return this.$store.getters.StateScreenSize },
        wallets() { return this.$store.getters.StateWallets },
        isWithdraw() { return this.partner && this.partner.wallet && this.partner.wallet.balance && this.partner.wallet.balance.$numberDecimal>=10 }
    },
    methods: {
        ...mapActions(['ActionGetWalletByType']),
        loadRules() {
            this.rules = partnerRules.slice(0, 100)
        },
        getPercent(value){
            if(!value) return ''
            if(value.$numberDecimal) return this.helper.get_percent(value.$numberDecimal)
            return this.helper.get_percent(value)
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        shareTg(url){
            if(!url) return ''
            const text = 'Удобный сервис быстрых переводов в пару кликов. Попробуй'
            window.open(`https://t.me/share/url?url=${url}&text=${text}`, '_blank')
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copy, detail: text, life: 1000 })
        },
        get_short_id(value){
            if(!value) return ''
            return this.helper.get_short_id(value)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        get_currency_label(val){
            return this.helper.get_currency_label(val)
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        getStatusLabel(status){
            return this.helper.get_severity_status(status, this.lang_)
        },

        // USERS
        onPageUser(event) {
            this.lazyParams = event
            this.load_users()
        },
        onSortUser(event) {
            this.lazyParams = event
            this.load_users()
        },            
        // загрузка пользователей
        async load_users(){
            this.loadingUsers = true
            window.scrollTo({ top: 0, behavior: 'smooth' })

            const limit = (this.lazyParams.rows) ? this.lazyParams.rows : 10
            const skip = (this.lazyParams.first) ? this.lazyParams.first : 0
            const sort = {date_created: -1}

            const res = await this.connect.get_referals(limit, skip, sort).then(res=>res)
            if(res.result && res.data){
                this.users = res.data
                this.totalUsers = res.total
            }
            this.loadingUsers = false
        },

        // TRANSFERS
        onPageTransfers(event) {
            this.lazyParams = event
            this.load_transfers()
        },
        onSortTransfers(event) {
            this.lazyParams = event
            this.load_transfers()
        },

        // загрузка переводов
        async load_transfers(){
            this.loadingTransfers = true
            window.scrollTo({ top: 0, behavior: 'smooth' })

            const limit = (this.lazyParams.rows) ? this.lazyParams.rows : 10
            const skip = (this.lazyParams.first) ? this.lazyParams.first : 0
            const sort = {date_created: -1}
            
            const res = await this.connect.get_ref_transfers(limit, skip, sort).then(res=>res)
            if(res.result && res.data){
                this.transfers = res.data
                this.totalTransfers = res.total

                this.totalComission = new BigNumber(0)
                for(let i=0; i<res.data.length; i++){
                    let comission = new BigNumber(res.data[i].partner_reward_amount.$numberDecimal)
                    this.totalComission = this.totalComission.plus(comission)
                }
                if(this.totalComission.isNaN()){
                    this.totalComission = new BigNumber(0)
                }
                this.totalComission = this.totalComission.toFixed(2)
            }
            this.loadingTransfers = false
        },

        // TRANS
        onPageTrans(event) {
            this.lazyParams = event
            this.loadTrans()
        },
        onSortTrans(event) {
            this.lazyParams = event
            this.loadTrans()
        },

        // загрузка переводов
        async loadTrans(){
            this.loadingTrans = true
            window.scrollTo({ top: 0, behavior: 'smooth' })

            const limit = (this.lazyParams.rows) ? this.lazyParams.rows : 10
            const skip = (this.lazyParams.first) ? this.lazyParams.first : 0
            
            const res = await this.connect.get_ref_trans(limit, skip).then(res=>res)
            if(res.result && res.data){
                this.trans = res.data
                this.totalTrans = res.total
            }
            this.loadingTrans = false
        },
        async loadPartner(){
            const bot_username = (this.$store.getters.StateBotUsername) ? this.$store.getters.StateBotUsername : 'pw_origin_bot'
            await this.connect.get_partner().then(res=>{
                if(res.result && res.data){
                    this.partner = res.data
                    this.partnerUserCount = 0
                    this.partnerTransferCount = 0
                    this.partnerTransCount = 0
                    if(this.partner.counted.users) this.partnerUserCount = this.partner.counted.users
                    if(this.partner.counted.transfers && this.partner.counted.transfers>0) this.partnerTransferCount = this.partner.counted.transfers
                    if(this.partner.counted.trans && this.partner.counted.trans>0) this.partnerTransCount = this.partner.counted.trans
                    if(this.partner.link) this.partner_link = this.partner.link
                    if(this.partner.ref.code) this.partner_link_tg = `t.me/${bot_username}/app?startapp=ref-${this.partner.ref.code}`
                    this.message_sum = (!this.partner || !this.partner.wallet || !this.partner.wallet.balance) ? 0 : this.partner.wallet.balance.$numberDecimal
                }
            })
        },
        getRestCount(){
            if(!this.partnerUserCount || !this.avatarCount) return null
            const count = this.partnerUserCount - this.avatarCount
            if(count>0) return `+${count}`
            return null
        },
        async loadAvatars(){            
            const res = await this.connect.get_ref_avatars().then(res=>res)
            if(res.result && res.data){
                this.avatars = res.data
                this.avatarCount = this.avatars.length
            }
        },
        async sendMessage() {
            this.isLoading = true
            const message = {
                amount: this.message_sum,
            }
            const send = await this.connect.sendMessage(message, 'request', []).then(res => res)
            if(send.result && send.data) this.showMess('success', this.message[this.lang_].success, this.message[this.lang_].sent)
            else this.showMess('error', this.message[this.lang_].error, this.message[this.lang_].notsent)
            this.showWithdrawPopup = false
            this.isLoading = false
        },
        getMaxSum(){
            if(!this.partner || !this.partner.wallet || !this.partner.wallet.balance) return 0
            return this.partner.wallet.balance.$numberDecimal
        },
        async getWallet(){
            if(!this.wallet) return
            this.isLoading = true
            try {
                const wallet_data = await this.ActionGetWalletByType('partner').then(res=>res)
                if(wallet_data.result) this.wallet = wallet_data.data
                else {
                    this.wallet = null
                    this.showMess('error', this.content[this.lang].error, this.content[this.lang].notfound)
                }
                this.isLoading = false
            } catch (error) {
                console.log(error)
                this.isLoading = false
            }
        }
    },
    watch: {
        showTableUsers: function (val) {
            if(val==true){
                this.lazyParams = this.defaulParams
                this.load_users()
            }
        },
        showTableTransfers: function (val) {
            if(val==true){
                this.lazyParams = this.defaulParams
                this.load_transfers()
            }
        },
        showTableTrans: function (val) {
            if(val==true){
                this.lazyParams = this.defaulParams
                this.loadTrans()
            }
        },
        show_invite: function (val) {
            this.showInvitePopUp = val
        },
        showInvitePopUp: function (val) {
            this.$emit('show', val)
        },
        active: function (val) {
            if(val==1 && !this.users) {
                this.lazyParams = this.defaulParams
                this.load_users()
            }
            if(val==2 && !this.transfers) {
                this.lazyParams = this.defaulParams
                this.load_transfers()
            }
        },
        message_sum: function (val) {
            if(val>this.getMaxSum()) this.message_sum = this.getMaxSum()
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.wallet = this.$store.getters.StateWalletByType('partner')
        if(this.wallet && this.wallet.id) this.wallet_id = this.wallet.id

        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        }
        await this.loadPartner()
        await this.loadAvatars()
        this.loadRules()
    }
}
</script>